<template>
  <div class="horizontal-line" :class="`horizontal-line-${position}`"></div>
</template>

<script>
export default {
  props: ["position"],
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";

.horizontal-line {
  position: absolute;
  left: 0;
  width: 100%;
  border: 1px solid black;
  &-before {
    top: 0;
    transform: translateY(-100%);
  }
  &-after {
    bottom: 0;
  }
}
</style>
